<p *ngIf="selectedDoor !== null">
  {{ 'STEP5.INSTRUCTIONSELECT' | translate }}
</p>
<p *ngIf="selectedDoor === null && choosingDoorType">
  {{ 'STEP5.INSTRUCTIONCHOOSEDOOR' | translate }}
</p>
<div *ngIf="selectedDoor !== null; else showNoDoorState">
  <div class="selected-door">
    <div class="door-space">
      <div class="door-image">
        <img [src]="getDoorImage(selectedDoor)" class="door-picture" height="57" />
      </div>
      <div class="door-type-text">{{ selectedDoorDescription() }}</div>
    </div>
    <div (click)="removeSelectedDoor()" class="delete-door">
      <div [inlineSVG]="'assets/svg/icon-trash.svg'" class="icon"></div>
    </div>
  </div>

  <div>
    <div class="label-pro-holder">
      {{ 'STEP5.CLEARWIDTH' | translate }}
      <div *ngIf="clearWidthPro" class="product-classification-box">
        <span class="product-classification-box-icon">Pro</span>
      </div>
    </div>
    <app-door-dimension-slider #doorWidth [range]="widthRange" [value]="doorOpeningWidth"></app-door-dimension-slider>
    <div class="label-pro-holder">
      {{ 'STEP5.CLEARHEIGHT' | translate }}
      <div *ngIf="clearHeightPro" class="product-classification-box">
        <span class="product-classification-box-icon">Pro</span>
      </div>
    </div>
    <app-door-dimension-slider
      #doorHeight
      [range]="heightRange"
      [value]="doorOpeningHeight"></app-door-dimension-slider>
  </div>

  <div class="title">{{ 'STEP5.POSITION' | translate }}</div>
  <app-step-five-slider
    #slider
    (newPositionFromLeft$)="newDoorLeftPosition($event)"
    [collided$]="collided$"></app-step-five-slider>

  <div *ngIf="!isSlideType" class="title">{{ 'STEP5.DIRECTION' | translate }}</div>
  <div *ngIf="isSlideType" class="title">{{ 'STEP5.SLIDEDIRECTION' | translate }}</div>
  <div class="two-buttons">
    <app-isomasters-button (modularClick)="setDirection(0)" [selected]="turnLeft" class="left">
      <div description>{{ 'STEP5.LEFT' | translate }}</div>
    </app-isomasters-button>
    <app-isomasters-button (modularClick)="setDirection(1)" [selected]="!turnLeft">
      <div description>{{ 'STEP5.RIGHT' | translate }}</div>
    </app-isomasters-button>
  </div>
  <ng-container *ngIf="selectedDoor.innerWallId !== undefined && selectedDoor.innerWallId !== null">
    <app-isomasters-button (modularClick)="flipInnerWall()">
      <div description>{{ 'STEPINNERWALL.FLIPWALL' | translate }}</div>
    </app-isomasters-button>
  </ng-container>
  <ng-container>
    <div class="title">{{ 'STEP6.FINISH' | translate }} {{ 'STEP6.OUTSIDESMALL' | translate }}</div>
    <app-isomasters-horizontal-viewbox
      (optionSelected$)="processSelectedExternalDoorFinish($event)"
      [needsBorderedFlaredImage]="true"
      [options]="externalDoorFinishTypes"></app-isomasters-horizontal-viewbox>
    <div class="title">{{ 'STEP6.FINISH' | translate }} {{ 'STEP6.INSIDESMALL' | translate }}</div>
    <app-isomasters-horizontal-viewbox
      (optionSelected$)="processSelectedInternalDoorFinish($event)"
      [needsBorderedFlaredImage]="true"
      [options]="internalDoorFinishTypes"></app-isomasters-horizontal-viewbox>
  </ng-container>
  <ng-container *ngIf="isTurnType">
    <div class="title">
      {{ 'DOORHANDLE.HANDLE' | translate }}
    </div>
    <app-isomasters-horizontal-viewbox
      (optionSelected$)="processSelectedDoorHandle($event)"
      [bigImagesNoBorders]="true"
      [options]="doorHandleTypes"></app-isomasters-horizontal-viewbox>
    <div class="title">
      {{ 'DOORHINGE.HINGE' | translate }}
    </div>
    <app-isomasters-horizontal-viewbox
      (optionSelected$)="processSelectedDoorHinge($event)"
      [bigImagesNoBorders]="true"
      [options]="doorHingeTypes"></app-isomasters-horizontal-viewbox>
  </ng-container>
</div>

<ng-template #showNoDoorState>
  <div *ngIf="choosingDoorType === false; else chooseDoorType">
    <div class="no-door-background">
      <div class="nodoor-icon">
        <img [src]="noDoorImage" height="100" />
      </div>
      <div class="instruction-text">
        <div class="text bold">{{ doorInstructionTitle }}</div>
        <div class="text">{{ doorInstructionText }}</div>
      </div>
    </div>
  </div>
  <ng-template #chooseDoorType>
    <div [class.disabled]="!canUseTurnDoor" class="turn">
      <app-isomasters-button
        (modularClick)="addDoorType(0)"
        [selected]="false"
        [style.height.px]="80"
        [style.padding-right.px]="24"
        [style.width.px]="80"
        class="door">
        <div content>
          <img class="door-picture" height="57" src="assets/images/doors/turning_left.png" />
        </div>
      </app-isomasters-button>
      <div class="description">{{ 'STEP5.TURN' | translate }}</div>
      <div (click)="addDoorType(0)" class="plus">
        <div class="icon">
          <div class="horizontal"></div>
          <div class="vertical"></div>
        </div>
      </div>
    </div>
    <div [class.disabled]="!canUseSlideDoor" class="slide">
      <app-isomasters-button
        (modularClick)="addDoorType(1)"
        [selected]="false"
        [style.height.px]="80"
        [style.padding-right.px]="24"
        [style.width.px]="80"
        class="door">
        <div content id="product-sliding-door">
          <img class="door-picture" height="57" src="assets/images/doors/sliding.png" />
        </div>
      </app-isomasters-button>
      <div class="description">
        {{ 'STEP5.SLIDE' | translate }}
        <div class="product-classification-box">
          <span
            [inlineSVG]="'assets/svg/pro.svg'"
            [setSVGAttributes]="{ height: '8px' }"
            class="product-classification-box-icon"></span>
        </div>
      </div>
      <div (click)="addDoorType(1)" class="plus">
        <div class="icon">
          <div class="horizontal"></div>
          <div class="vertical"></div>
        </div>
      </div>
    </div>
  </ng-template>
</ng-template>
